import { Grid } from 'antd';

export const useMobile = () => {
  const { useBreakpoint } = Grid;
  const width = useBreakpoint();
  const isMobile = !width.md && !width.lg && !width.xl;
  return { isMobile};
};
